<template>
  <div>
    <div class="subtitle-1 font-weight-bold text-center primary--text">
      {{ label }}
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
  },
};
</script>

<style></style>
